import { createContext, useContext, useState, useCallback } from "react";
import { APP_D } from "@/i18n/app";
import { MAN_D } from "@/i18n/manual";
import { PAGE_D } from "@/i18n/pages";

const LANGS = [
  { id: "it", label: "Italiano", flag: "IT" },
  { id: "en", label: "English", flag: "EN" },
  { id: "fr", label: "Français", flag: "FR" },
  { id: "de", label: "Deutsch", flag: "DE" },
];

const D = {
  it: {
    "nav.enter": "Entra nel gestionale",
    "nav.try": "Prova gratis",
    "hero.badge": "Gestionale per ristoranti, pizzerie e bar",
    "hero.title": "Il gestionale che fa respirare il tuo locale.",
    "hero.sub": "Dalla presa comanda alla cucina, dal delivery allo scontrino. Reprehendo unisce sala, cucina e cassa in un unico flusso. Crea la tua demo su misura in 60 secondi.",
    "hero.cta": "Provalo gratis in 60 secondi",
    "cf.overline": "Dimostrazione con voce",
    "cf.title": "Guarda come funziona, in due minuti",
    "cf.sub": "Una serata vera, dall'inizio alla fine: tavolo, comanda, cucina, conto. Con la voce che spiega e i sottotitoli sempre visibili.",
    "cf.play": "Guarda come funziona",
    "cf.resume": "Riprendi",
    "cf.pause": "Pausa",
    "cf.again": "Da capo",
    "cf.mute": "Silenzia",
    "cf.unmute": "Attiva la voce",
    "cf.back": "Torna alla pagina principale",
    "cf.loading": "Preparo la dimostrazione…",
    "cf.note": "Nessuna registrazione: quello che vedi è il funzionamento reale dell'app. La voce parte al tocco, come su ogni telefono.",
    "cf.cta": "Provalo sul mio locale",
    "cf.cta.sub": "Ti serve un minuto: rispondi a poche domande e trovi la tua demo già pronta, con menu e tavoli.",
    "cf.step.sala": "Sala",
    "cf.step.comanda": "Comanda",
    "cf.step.cucina": "Cucina",
    "cf.step.pronto": "Pronto",
    "cf.step.conto": "Conto",
    "cf.scene.sala": "Tavoli in sala",
    "cf.scene.comanda": "Comanda del tavolo S3",
    "cf.scene.cucina": "Monitor cucina",
    "cf.scene.conto": "Conto tavolo S3",
    "cf.tap": "Da servire",
    "cf.free": "Libero",
    "cf.course1": "Primo",
    "cf.course2": "Pizza",
    "cf.send": "Manda in cucina",
    "cf.cooking": "In preparazione",
    "cf.oven": "Al forno",
    "cf.ready": "Pronto",
    "cf.voice": "«Carbonara pronta, tavolo S3»",
    "cf.total": "Totale",
    "cf.cash": "Incassa",
    "cf.split": "Dividi",
    "cf.step.asporto": "Asporto",
    "cf.step.magazzino": "Magazzino",
    "cf.step.chiusura": "Chiusura",
    "cf.step.prezzi": "Prova",
    "cf.scene.asporto": "Asporto e consegne",
    "cf.scene.magazzino": "Scorte di magazzino",
    "cf.scene.chiusura": "Chiusura di cassa",
    "cf.scene.prezzi": "Piani e prova gratuita",
    "cf.pickup": "Ritiro",
    "cf.delivery": "Consegna",
    "cf.items": "piatti",
    "cf.asporto.badge": "Sala e asporto nello stesso servizio",
    "cf.stock.low": "Sotto la soglia",
    "cf.stock.ok": "Disponibile",
    "cf.stock.alert": "Guanciale in esaurimento: ordina",
    "cf.cashline": "Contanti",
    "cf.cardline": "Carte",
    "cf.float": "Fondo cassa",
    "cf.dayTotal": "Incasso di giornata",
    "cf.balanced": "Cassa quadrata, nessuna differenza",
    "cf.plan.f1": "Comande, cucina e cassa",
    "cf.plan.f2": "Asporto, magazzino e prenotazioni",
    "cf.plan.f3": "Voce in cucina e statistiche",
    "cf.plan.freeNow": "Gratis durante la beta",
    "cf.plan.note": "Nessuna carta di credito",
    "cf.step.prenotazioni": "Prenotazioni",
    "cf.scene.prenotazioni": "Prenotazioni della sera",
    "cf.scene.prezzi": "Tutto incluso, in beta",
    "cf.book.incoming": "Chiamata: «Un tavolo per stasera?»",
    "cf.book.confirmed": "Confermata",
    "cf.book.waiting": "In lista d'attesa",
    "cf.book.badge": "Aggiungi prenotazione",
    "hero.note": "7 giorni gratis · nessuna carta di credito · configurata sulla tua attività",
    "feat.overline": "Funzionalità",
    "feat.title": "Tutto sotto controllo. Niente più caos.",
    "feat.orders.t": "Comande e reparti",
    "feat.orders.d": "Dividi per portate e invia a Cucina, Pizzeria o Bar. Ogni piatto ha il suo stato, dal fuoco al tavolo.",
    "feat.voice.t": "Monitor con voce",
    "feat.voice.d": "La comanda viene letta ad alta voce: le mani sporche di farina non sono più un problema.",
    "feat.split.t": "Conti separati",
    "feat.split.d": "Dividi per persone o per piatti in tre tocchi. Zero fila in cassa.",
    "feat.delivery.t": "Asporto e delivery",
    "feat.delivery.d": "Glovo, Deliveroo, Just Eat e Uber Eats con commissioni già impostate.",
    "feat.stock.t": "Magazzino e ricette",
    "feat.stock.d": "Ingredienti collegati ai piatti e scarico automatico all'invio della comanda.",
    "feat.alerts.t": "Tavoli che ti chiamano",
    "feat.alerts.d": "Il tavolo lampeggia e suona dopo dieci minuti di attesa: nessuno resta dimenticato.",
    "feat.calls.t": "Chiamate dal tavolo",
    "feat.calls.d": "Il cliente inquadra il QR e con un tocco chiede il cameriere o il conto: la richiesta arriva in sala col numero del tavolo.",
    "feat.report.t": "Report di chiusura",
    "feat.report.d": "A serata archiviata ricevi per email incassi, coperti, differenza di cassa e piatti più venduti.",
    "news.overline": "Aggiornamenti",
    "news.title": "Il prodotto cresce ogni settimana.",
    "news.sub": "Le ultime funzioni entrate in servizio. Nessun costo aggiuntivo: arrivano a tutti i locali.",
    "news.more": "Novità di questa versione",
    "how.overline": "Come funziona",
    "how.title": "Pronto in 3 passi, senza tecnici.",
    "how.1.t": "Rispondi a 6 domande",
    "how.1.d": "Ci dici che attività hai, come servi e quali reparti ti servono.",
    "how.2.t": "Prova per 7 giorni",
    "how.2.d": "Ricevi la tua app già configurata, con menu di partenza e tavoli pronti.",
    "how.3.t": "Scegli il piano",
    "how.3.d": "Passi ad abbonamento conservando menu, tavoli e tutti i dati inseriti.",
    "trust.overline": "Privacy",
    "trust.title": "Chi vede i tuoi incassi? Nessuno, a parte te.",
    "trust.sub": "È la domanda giusta da farsi prima di firmare qualsiasi cosa. Ecco la risposta, riga per riga.",
    "trust.seeT": "Cosa vediamo noi",
    "trust.see1": "Nome del locale, referente, piano e scadenza",
    "trust.see2": "Quanti piatti, quanti tavoli, quante persone in squadra",
    "trust.see3": "Quali funzioni hai attivato, e le tue richieste di assistenza",
    "trust.notT": "Cosa non vediamo mai",
    "trust.not1": "I tuoi incassi: nessun importo, nessun totale, nessuna statistica",
    "trust.not2": "Conti, pagamenti, mance, fondi cassa e conteggi dei contanti",
    "trust.not3": "I dati dei tuoi clienti e dei tuoi dipendenti",
    "trust.note": "Nessuno dell\u2019assistenza entra nel tuo gestionale senza il tuo «Autorizza»: l\u2019accesso vale un\u2019ora, si chiude da solo e resta scritto nel tuo registro.",
    "trust.cta": "Leggi tutte le garanzie",
    "price.overline": "Piani e prezzi",
    "price.title": "Prezzi chiari, nessuna sorpresa.",
    "price.sub": "Cambi piano quando vuoi. Tutti i piani includono aggiornamenti e assistenza.",
    "price.month": "al mese",
    "price.cta": "Inizia la prova",
    "price.popular": "Il più scelto",
    "plan.free.h": "Sala, tavoli e comande|Portate e monitor reparti|Conto e incassi|20 prenotazioni al mese|1 utente",
    "plan.standard.h": "Prenotazioni illimitate|Comande lette a voce|Asporto e delivery|Agenda e lista d'attesa|Storico ordini|Fino a 3 utenti",
    "plan.pro.h": "Tutto lo Standard|Report vendite mensili|Magazzino con ricette e scarico automatico|Piantina e zone personalizzate|Rubrica clienti e archivio|Import menu da PDF o Excel|Utenti illimitati",
    "final.title": "Facciamo entrare ordine nel tuo servizio.",
    "final.sub": "Il questionario dura un minuto e ti restituisce l'app già montata sulla tua attività.",
    "footer.tag": "Gestionale per la ristorazione · sala, cucina, cassa e delivery in un unico posto.",
    "footer.rights": "Tutti i diritti riservati.",
    "footer.terms": "Condizioni di utilizzo", "footer.privacy": "Informativa privacy", "footer.security": "Sicurezza dei dati",
    "footer.status": "Stato del servizio",
    "wiz.accept.pre": "Ho letto e accetto le", "wiz.accept.terms": "condizioni di utilizzo",
    "wiz.accept.and": "e l'", "wiz.accept.privacy": "informativa privacy",
    "wiz.accept.beta": "Ho capito che il prodotto è in versione beta, che gira su infrastruttura di terzi e che non sostituisce il registratore di cassa fiscale.",
    "wiz.err.accept": "Per attivare la prova devi accettare le condizioni",
    "wiz.public": "Scopri la tua soluzione",
    "wiz.setup": "Configurazione iniziale",
    "wiz.step": "domanda {n} di {tot}",
    "wiz.recap": "riepilogo",
    "wiz.q0": "Che tipo di attività hai?",
    "wiz.q1": "Come servi i tuoi clienti?",
    "wiz.q2": "Quali reparti devono ricevere le comande?",
    "wiz.q3": "Dove sono i tuoi tavoli?",
    "wiz.q4": "Quante persone lavorano con te?",
    "sit.cashed": "Incassato",
    "sit.cashedSub": "soldi già in cassa",
    "sit.toCollect": "Da incassare",
    "sit.toCollectSub": "{n} tavoli aperti",
    "sit.cashExpected": "Contanti attesi",
    "sit.cashExpectedSub": "compresi {v} di fondo cassa",
    "sit.lastCount": "Ultima conta",
    "sit.lastCountSub": "differenza sui contanti",
    "sit.noCount": "ancora da fare",
    "sr.vsPast": "{p}% sui {n} stessi giorni precedenti",
    "sr.precloseTitle": "Chiudo la serata?",
    "sr.precloseIntro": "Controlla cosa resta indietro: dopo la chiusura i tavoli aperti vengono chiusi e archiviati.",
    "sr.precloseMoney": "Attenzione: {v} non ancora incassati. Chiudendo adesso restano fuori.",
    "sr.precloseOk": "Sì, chiudi la serata",
    "sr.precloseAnyway": "Chiudi comunque",
    "sr.precloseErr": "Controlli non disponibili",
    "wiz.q5": "Quali di queste funzioni ti servono?",
    "wiz.q6": "La tua app Reprehendo",
    "wiz.h5": "Sono funzioni che non usano tutti: accendi solo quelle che ti interessano, le altre non compaiono nel tuo gestionale. Si aggiungono quando vuoi.",
    "wiz.extra.menu_fisso.t": "Menu fisso del giorno",
    "wiz.extra.menu_fisso.d": "Menu completo a prezzo unico: il cameriere sceglie i piatti in comanda e sul conto va una riga sola",
    "wiz.extra.carta_qr.t": "Carta digitale con QR sul tavolo",
    "wiz.extra.carta_qr.d": "I clienti leggono il menu dal telefono: nessuna ristampa quando cambi un prezzo",
    "wiz.extra.cassa_fiscale.t": "Collegamento alla cassa fiscale",
    "wiz.extra.cassa_fiscale.d": "L'app prepara lo scontrino per il tuo registratore (Epson, RCH, Ditron, Custom, Olivetti)",
    "wiz.banco.q": "Hai un banco di tavola calda o fredda?",
    "wiz.banco.tavola-calda.t": "Tavola calda",
    "wiz.banco.tavola-calda.d": "Primi e secondi caldi, toast, piadine, panini caldi, rosticceria",
    "wiz.banco.tavola-fredda.t": "Tavola fredda",
    "wiz.banco.tavola-fredda.d": "Insalate, tramezzini, panini freddi, gastronomia e salumi",
    "wiz.extra.note": "Non sei sicuro? Lascia spento: si accende in due tocchi da «Funzioni attive».",
    "wiz.h0": "Puoi scegliere più voci: bar e pizzeria, ristorante e bar, tutte e tre… come sei nella realtà.",
    "wiz.other": "Raccontaci in due parole la tua attività (es. agriturismo, chiosco)",
    "wiz.h2": "Ogni reparto ha il suo monitor: i piatti arrivano solo a chi li prepara. Abbiamo già selezionato quelli tipici della tua attività, ma decidi tu.",
    "wiz.menu.t": "Carica un menu di partenza",
    "wiz.menu.d": "Piatti tipici dei reparti scelti, poi modificabili in un attimo",
    "wiz.h3": "Creeremo le zone scelte con la loro sigla (S1, D1, G1…).",
    "wiz.team.solo": "Solo io",
    "wiz.float.t": "Chi incassa tiene un suo fondo cassa?",
    "wiz.float.d": "Tipico del dehor: il cameriere incassa al tavolo e dà il resto dal suo fondo.",
    "wiz.float.amount": "Fondo a persona (€)",
    "wiz.float.outdoor": "Persone fuori",
    "wiz.motto.t": "Il motto del tuo locale (facoltativo)",
    "wiz.motto.ph": "Es. Dal 1962, la pizza si fa a mano",
    "wiz.motto.d": "Comparirà nella schermata di accesso dello staff e sul conto del cliente. Si cambia quando vuoi da Impostazioni.",
    "wiz.float.note": "A fine serata vedrai per ognuno quanto ha in mano e quanto deve versare. Si cambia quando vuoi: chi fa il dehor può fare anche la sala.",
    "wiz.team.more": "Più di 10",
    "wiz.team.people": "{n} persone",
    "wiz.plan": "Piano consigliato",
    "wiz.sum.act": "Attività",
    "wiz.sum.serv": "Servizio",
    "wiz.sum.dept": "Reparti attivi",
    "wiz.sum.zones": "Zone",
    "wiz.sum.mods": "Funzioni attivate",
    "wiz.sum.note": "Tutto resta modificabile: da Funzioni attive puoi accendere o spegnere qualsiasi modulo quando vuoi.",
    "wiz.back": "Indietro",
    "wiz.next": "Avanti",
    "wiz.apply": "Crea la mia app",
    "wiz.name": "Nome del tuo locale",
    "wiz.email": "La tua email",
    "wiz.trial": "Prova la demo configurata",
    "wiz.trial.note": "Ti scriviamo solo per il promemoria di scadenza della prova.",
    "wiz.err.act": "Scegli almeno un tipo di attività",
    "wiz.err.dept": "Scegli almeno un reparto",
    "wiz.err.email": "Inserisci un'email valida per attivare la prova",
    "wiz.vat": "Partita IVA (o codice fiscale)",
    "wiz.vat.note": "La partita IVA identifica in modo univoco il tuo locale: si registra una volta sola. Tutto il resto (nome, indirizzo, telefono, menu) lo completi o lo correggi dopo, dal tuo account.",
    "wiz.err.vat": "Inserisci una partita IVA valida (11 cifre), oppure il codice fiscale o la P.IVA estera",
    "wiz.loading": "Caricamento del test…",
    "login.title": "Accesso attività",
    "login.sub": "Entra con il nome della tua attività e il codice ricevuto.",
    "login.name": "Nome attività",
    "login.code": "Codice di accesso",
    "login.btn": "Entra",
    "login.quiz": "Scopri la tua soluzione in 1 minuto",
    "login.back": "Torna alla presentazione",
    "trial.ready": "La tua demo configurata è pronta per {n} giorni",
    "login.lost": "Ho perso il codice di accesso",
    "hero.have": "Ho già un locale registrato",
    "rec.title": "Ho perso il codice",
    "rec.sub": "Scrivi l'email con cui hai attivato il locale: ti mando un link per rientrare subito e il nuovo codice.",
    "rec.email": "La tua email",
    "rec.send": "Mandami il link",
    "rec.note": "Per sicurezza il codice precedente viene sostituito con quello nuovo.",
    "rec.done": "Fatto: se l'email è quella registrata, fra poco ricevi il link. Vale 30 minuti.",
    "rec.ok": "Ho capito",
    "rec.entered": "Bentornato in {name}",
    "rec.expired": "Link scaduto: richiedilo di nuovo",
    "ob.title": "Primi passi",
    "ob.sub": "Fatti {n} di 4. Tocca una riga e ti porto dove serve.",
    "ob.hide": "Nascondi",
    "ob.step.tavolo": "Apri un tavolo in Sala",
    "ob.step.comanda": "Aggiungi due piatti alla comanda",
    "ob.step.cucina": "Mandali in cucina e guarda il monitor",
    "ob.step.conto": "Chiudi il conto e incassa",
    "ob.help": "Trovi tutto spiegato passo per passo in «Manuale», nel menu.", "ob.helpDemo": "Trovi le poche cose che servono in «Guida rapida», nel menu.",
    "done.title": "Il tuo locale è pronto",
    "done.sub": "Puoi usarlo per {n} giorni con tutte le funzioni attive.",
    "done.venue": "Nome attività", "done.code": "Codice di accesso", "done.pin": "PIN titolare",
    "done.copy": "Copia i dati", "done.copied": "Dati copiati",
    "done.enter": "Entra nel locale",
    "done.mail": "Ti ho mandato questi dati anche per email a {mail}: conservala, ti serve per rientrare da un altro telefono.",
    "done.next": "Appena entri trovi «Primi passi»: quattro cose da provare per capire tutto in cinque minuti.",
    "trial.how": "Entra come Titolare con il PIN {pin}. Per rientrare: attività {slug}, codice {code} — conservalo.",
    "trial.left": "Prova gratuita: restano {n} giorni",
    "install.title": "Tienilo sul telefono",
    "install.sub": "Aggiungi Reprehendo alla schermata Home: si apre a tutto schermo, come un'app.",
    "install.ios": "Su iPhone: tocca Condividi, poi «Aggiungi alla schermata Home».",
    "install.iosStep": "Condividi → Aggiungi a Home",
    "install.cta": "Aggiungi alla Home",
    "install.later": "Più tardi",
    "install.titlePc": "Tienilo sul computer",
    "install.subPc": "Installa Reprehendo: si apre in una sua finestra, senza barre del browser.",
    "install.ctaPc": "Installa sul computer",
    "install.manual": "Dal menu del browser scegli «Installa» o «Aggiungi alla schermata Home».",
    "install.manualStep": "Menu → Installa",
    "nav.installa": "Installa l'app",
    "trial.over": "Prova terminata: sei sul piano Gratuito",
    "trial.overKeep": "Sala, comande, monitor e conto restano attivi. I tuoi dati vengono conservati ancora {n} giorni.",
    "trial.reactivate": "Riattiva tutte le funzioni",
    "trial.keep": "Attiva un abbonamento e conservi menu, tavoli e tutti i dati.",
    "trial.activate": "Attiva l'abbonamento",
  },
  en: {
    "nav.enter": "Sign in to the app",
    "nav.try": "Try for free",
    "hero.badge": "Management app for restaurants, pizzerias and bars",
    "hero.title": "The system that lets your venue breathe.",
    "hero.sub": "From taking the order to the kitchen, from delivery to the receipt. Reprehendo brings floor, kitchen and till into one flow. Build your tailored demo in 60 seconds.",
    "hero.cta": "Try it free in 60 seconds",
    "cf.overline": "Narrated walkthrough",
    "cf.title": "See how it works, in two minutes",
    "cf.sub": "A real service from start to finish: table, order, kitchen, bill. With a voice explaining and subtitles always on.",
    "cf.play": "See how it works",
    "cf.resume": "Resume",
    "cf.pause": "Pause",
    "cf.again": "Start over",
    "cf.mute": "Mute",
    "cf.unmute": "Turn voice on",
    "cf.back": "Back to the main page",
    "cf.loading": "Getting the walkthrough ready…",
    "cf.note": "No recording: what you see is how the app really works. The voice starts on tap, as on every phone.",
    "cf.cta": "Try it on my venue",
    "cf.cta.sub": "It takes a minute: answer a few questions and your demo is ready, with menu and tables.",
    "cf.step.sala": "Floor",
    "cf.step.comanda": "Order",
    "cf.step.cucina": "Kitchen",
    "cf.step.pronto": "Ready",
    "cf.step.conto": "Bill",
    "cf.scene.sala": "Tables on the floor",
    "cf.scene.comanda": "Order for table S3",
    "cf.scene.cucina": "Kitchen monitor",
    "cf.scene.conto": "Bill table S3",
    "cf.tap": "To serve",
    "cf.free": "Free",
    "cf.course1": "Pasta",
    "cf.course2": "Pizza",
    "cf.send": "Send to kitchen",
    "cf.cooking": "Cooking",
    "cf.oven": "In the oven",
    "cf.ready": "Ready",
    "cf.voice": "“Carbonara ready, table S3”",
    "cf.total": "Total",
    "cf.cash": "Take payment",
    "cf.split": "Split",
    "cf.step.asporto": "Takeaway",
    "cf.step.magazzino": "Stock",
    "cf.step.chiusura": "Closing",
    "cf.step.prezzi": "Try it",
    "cf.scene.asporto": "Takeaway and delivery",
    "cf.scene.magazzino": "Stock levels",
    "cf.scene.chiusura": "Till closing",
    "cf.scene.prezzi": "Plans and free trial",
    "cf.pickup": "Pickup",
    "cf.delivery": "Delivery",
    "cf.items": "items",
    "cf.asporto.badge": "Room and takeaway in one service",
    "cf.stock.low": "Below threshold",
    "cf.stock.ok": "In stock",
    "cf.stock.alert": "Guanciale running low: reorder",
    "cf.cashline": "Cash",
    "cf.cardline": "Cards",
    "cf.float": "Till float",
    "cf.dayTotal": "Takings today",
    "cf.balanced": "Till balanced, no difference",
    "cf.plan.f1": "Orders, kitchen and till",
    "cf.plan.f2": "Takeaway, stock and bookings",
    "cf.plan.f3": "Kitchen voice and reports",
    "cf.plan.freeNow": "Free during the beta",
    "cf.plan.note": "No credit card",
    "cf.step.prenotazioni": "Bookings",
    "cf.scene.prenotazioni": "Tonight's bookings",
    "cf.scene.prezzi": "All included, in beta",
    "cf.book.incoming": "Call: “A table for tonight?”",
    "cf.book.confirmed": "Confirmed",
    "cf.book.waiting": "On the waiting list",
    "cf.book.badge": "Add booking",
    "hero.note": "7 days free · no credit card · configured around your business",
    "feat.overline": "Features",
    "feat.title": "Everything under control. No more chaos.",
    "feat.orders.t": "Orders and stations",
    "feat.orders.d": "Split by course and send to Kitchen, Pizzeria or Bar. Every dish has its own status, from the stove to the table.",
    "feat.voice.t": "Monitors that speak",
    "feat.voice.d": "Orders are read out loud, so floury hands are no longer a problem.",
    "feat.split.t": "Split bills",
    "feat.split.d": "Split by people or by dishes in three taps. No queue at the till.",
    "feat.delivery.t": "Takeaway and delivery",
    "feat.delivery.d": "Glovo, Deliveroo, Just Eat and Uber Eats with commissions already set.",
    "feat.stock.t": "Stock and recipes",
    "feat.stock.d": "Ingredients linked to dishes and deducted automatically when the order is sent.",
    "feat.alerts.t": "Tables that call you",
    "feat.alerts.d": "The table flashes and beeps after ten minutes of waiting: nobody gets forgotten.",
    "feat.calls.t": "Calls from the table",
    "feat.calls.d": "Guests scan the QR code and ask for the waiter or the bill with one tap: the request reaches the floor with the table number.",
    "feat.report.t": "Closing report",
    "feat.report.d": "Once the evening is filed you get takings, covers, cash difference and best sellers by email.",
    "news.overline": "Updates",
    "news.title": "The product grows every week.",
    "news.sub": "The latest features now live. No extra cost: every venue gets them.",
    "news.more": "What is new in this version",
    "how.overline": "How it works",
    "how.title": "Ready in 3 steps, no technician needed.",
    "how.1.t": "Answer 6 questions",
    "how.1.d": "Tell us your type of business, how you serve and which stations you need.",
    "how.2.t": "Try it for 7 days",
    "how.2.d": "You get your app already configured, with a starter menu and tables ready.",
    "how.3.t": "Pick your plan",
    "how.3.d": "Move to a subscription keeping your menu, tables and all your data.",
    "trust.overline": "Privacy",
    "trust.title": "Who sees your takings? Nobody but you.",
    "trust.sub": "It is the right question to ask before signing anything. Here is the answer, line by line.",
    "trust.seeT": "What we can see",
    "trust.see1": "Venue name, contact person, plan and renewal date",
    "trust.see2": "How many dishes, tables and staff members you have",
    "trust.see3": "Which features you switched on, and your support requests",
    "trust.notT": "What we never see",
    "trust.not1": "Your takings: no amount, no total, no sales statistic",
    "trust.not2": "Bills, payments, tips, cash floats and cash counts",
    "trust.not3": "Your customers\u2019 and your staff\u2019s data",
    "trust.note": "Nobody from support enters your system without your approval: access lasts one hour, closes by itself and stays written in your log.",
    "trust.cta": "Read all the guarantees",
    "price.overline": "Plans and pricing",
    "price.title": "Clear pricing, no surprises.",
    "price.sub": "Change plan whenever you like. Every plan includes updates and support.",
    "price.month": "per month",
    "price.cta": "Start the trial",
    "price.popular": "Most chosen",
    "plan.free.h": "Floor, tables and orders|Courses and station monitors|Bills and payments|20 bookings a month|1 user",
    "plan.standard.h": "Unlimited bookings|Orders read out loud|Takeaway and delivery|Diary and waiting list|Order history|Up to 3 users",
    "plan.pro.h": "Everything in Standard|Monthly sales reports|Stock with recipes and auto deduction|Custom floor plan and areas|Customer book and archive|Menu import from PDF or Excel|Unlimited users",
    "final.title": "Let's bring order to your service.",
    "final.sub": "The questionnaire takes a minute and hands you the app already built around your venue.",
    "footer.tag": "Hospitality management · floor, kitchen, till and delivery in one place.",
    "footer.rights": "All rights reserved.",
    "footer.terms": "Terms of use", "footer.privacy": "Privacy notice", "footer.security": "Data security",
    "footer.status": "Service status",
    "wiz.accept.pre": "I have read and accept the", "wiz.accept.terms": "terms of use",
    "wiz.accept.and": "and the", "wiz.accept.privacy": "privacy notice",
    "wiz.accept.beta": "I understand the product is in beta, runs on third-party infrastructure and does not replace a fiscal till.",
    "wiz.err.accept": "To start the trial you must accept the terms",
    "wiz.public": "Find your setup",
    "wiz.setup": "Initial setup",
    "wiz.step": "question {n} of {tot}",
    "wiz.recap": "summary",
    "wiz.q0": "What kind of business do you run?",
    "wiz.q1": "How do you serve your guests?",
    "wiz.q2": "Which stations should receive the orders?",
    "wiz.q3": "Where are your tables?",
    "wiz.q4": "How many people work with you?",
    "sit.cashed": "Cashed in",
    "sit.cashedSub": "money already in the till",
    "sit.toCollect": "Still to collect",
    "sit.toCollectSub": "{n} open tables",
    "sit.cashExpected": "Cash expected",
    "sit.cashExpectedSub": "including {v} of float",
    "sit.lastCount": "Last count",
    "sit.lastCountSub": "cash difference",
    "sit.noCount": "not done yet",
    "sr.vsPast": "{p}% vs the last {n} same weekdays",
    "sr.precloseTitle": "Close the service?",
    "sr.precloseIntro": "Check what is left behind: closing also closes and archives the open tables.",
    "sr.precloseMoney": "Careful: {v} not collected yet. Closing now leaves it out.",
    "sr.precloseOk": "Yes, close the service",
    "sr.precloseAnyway": "Close anyway",
    "sr.precloseErr": "Checks not available",
    "wiz.q5": "Which of these do you need?",
    "wiz.q6": "Your Reprehendo app",
    "wiz.h5": "Not everyone uses these: turn on only what you need, the rest stays out of your app. You can add them any time.",
    "wiz.extra.menu_fisso.t": "Fixed daily menu",
    "wiz.extra.menu_fisso.d": "Set-price menu: the waiter picks the dishes while ordering and the bill shows one line",
    "wiz.extra.carta_qr.t": "Digital menu with a QR on the table",
    "wiz.extra.carta_qr.d": "Guests read the menu on their phone: no reprinting when a price changes",
    "wiz.extra.cassa_fiscale.t": "Fiscal register link",
    "wiz.extra.cassa_fiscale.d": "The app prepares the receipt for your register (Epson, RCH, Ditron, Custom, Olivetti)",
    "wiz.banco.q": "Do you have a hot or cold counter?",
    "wiz.banco.tavola-calda.t": "Hot counter",
    "wiz.banco.tavola-calda.d": "Hot dishes, toasted sandwiches, wraps, rotisserie",
    "wiz.banco.tavola-fredda.t": "Cold counter",
    "wiz.banco.tavola-fredda.d": "Salads, sandwiches, deli and cold cuts",
    "wiz.extra.note": "Not sure? Leave it off: two taps in «Active features» turn it on.",
    "wiz.h0": "You can pick more than one: bar and pizzeria, restaurant and bar, all three… just as you really are.",
    "wiz.other": "Tell us in a few words what you run (e.g. farmhouse, kiosk)",
    "wiz.h2": "Every station has its own monitor: dishes only reach whoever cooks them. We already picked the usual ones for you, but it's your call.",
    "wiz.menu.t": "Load a starter menu",
    "wiz.menu.d": "Typical dishes for the stations you chose, editable in seconds",
    "wiz.h3": "We'll create the areas you choose with their own prefix (S1, D1, G1…).",
    "wiz.team.solo": "Just me",
    "wiz.float.t": "Does whoever takes payment keep their own float?",
    "wiz.float.d": "Typical outdoors: the waiter takes payment at the table and gives change from their float.",
    "wiz.float.amount": "Float per person (€)",
    "wiz.float.outdoor": "People outside",
    "wiz.motto.t": "Your venue motto (optional)",
    "wiz.motto.ph": "E.g. Since 1962, pizza made by hand",
    "wiz.motto.d": "It will appear on the staff sign-in screen and on the guest bill. Change it any time in Settings.",
    "wiz.float.note": "At the end of service you'll see how much each person holds and how much they must hand in. Change it any time: outdoor staff can work indoors too.",
    "wiz.team.more": "More than 10",
    "wiz.team.people": "{n} people",
    "wiz.plan": "Suggested plan",
    "wiz.sum.act": "Business",
    "wiz.sum.serv": "Service",
    "wiz.sum.dept": "Active stations",
    "wiz.sum.zones": "Areas",
    "wiz.sum.mods": "Enabled features",
    "wiz.sum.note": "Nothing is set in stone: from Active features you can switch any module on or off whenever you want.",
    "wiz.back": "Back",
    "wiz.next": "Next",
    "wiz.apply": "Build my app",
    "wiz.name": "Your venue name",
    "wiz.email": "Your email",
    "wiz.trial": "Try the tailored demo",
    "wiz.trial.note": "We only write to remind you when the trial is about to end.",
    "wiz.err.act": "Pick at least one type of business",
    "wiz.err.dept": "Pick at least one station",
    "wiz.err.email": "Enter a valid email to start the trial",
    "wiz.vat": "VAT number (or tax code)",
    "wiz.vat.note": "The VAT number uniquely identifies your venue: it is registered only once. Everything else (name, address, phone, menu) you can complete or fix later from your account.",
    "wiz.err.vat": "Enter a valid VAT number (11 digits), or a tax code / foreign VAT",
    "wiz.loading": "Loading the questionnaire…",
    "login.title": "Venue sign in",
    "login.sub": "Sign in with your venue name and the code you received.",
    "login.name": "Venue name",
    "login.code": "Access code",
    "login.btn": "Sign in",
    "login.quiz": "Find your setup in 1 minute",
    "login.back": "Back to the overview",
    "trial.ready": "Your tailored demo is ready for {n} days",
    "login.lost": "I lost my access code",
    "hero.have": "I already have a venue",
    "rec.title": "I lost my code",
    "rec.sub": "Type the email you used to start the venue: we send a link to get straight back in, plus the new code.",
    "rec.email": "Your email",
    "rec.send": "Send me the link",
    "rec.note": "For safety the previous code is replaced with the new one.",
    "rec.done": "Done: if that email is the registered one, the link is on its way. It lasts 30 minutes.",
    "rec.ok": "Got it",
    "rec.entered": "Welcome back to {name}",
    "rec.expired": "Link expired: please request a new one",
    "ob.title": "First steps",
    "ob.sub": "{n} of 4 done. Tap a line and we take you there.",
    "ob.hide": "Hide",
    "ob.step.tavolo": "Open a table on the Floor",
    "ob.step.comanda": "Add two dishes to the order",
    "ob.step.cucina": "Send them to the kitchen and watch the monitor",
    "ob.step.conto": "Close the bill and take payment",
    "ob.help": "Everything is explained step by step in «Manual», in the menu.", "ob.helpDemo": "The few things you need are in «Quick guide», in the menu.",
    "done.title": "Your venue is ready",
    "done.sub": "You can use it for {n} days with every feature on.",
    "done.venue": "Venue name", "done.code": "Access code", "done.pin": "Owner PIN",
    "done.copy": "Copy details", "done.copied": "Details copied",
    "done.enter": "Enter the venue",
    "done.mail": "We also emailed these details to {mail}: keep it, you need it to sign in from another phone.",
    "done.next": "Once inside you will find «First steps»: four things to try to get it in five minutes.",
    "trial.how": "Sign in as Owner with PIN {pin}. To come back: venue {slug}, code {code} — keep it safe.",
    "trial.left": "Free trial: {n} days left",
    "install.title": "Keep it on your phone",
    "install.sub": "Add Reprehendo to your Home screen: it opens full screen, like an app.",
    "install.ios": "On iPhone: tap Share, then “Add to Home Screen”.",
    "install.iosStep": "Share → Add to Home",
    "install.cta": "Add to Home screen",
    "install.later": "Later",
    "install.titlePc": "Keep it on your computer",
    "install.subPc": "Install Reprehendo: it opens in its own window, with no browser bars.",
    "install.ctaPc": "Install on computer",
    "install.manual": "From the browser menu choose “Install” or “Add to Home screen”.",
    "install.manualStep": "Menu → Install",
    "nav.installa": "Install the app",
    "trial.over": "Trial ended: you are on the Free plan",
    "trial.overKeep": "Floor, orders, monitors and bills stay on. Your data is kept for {n} more days.",
    "trial.reactivate": "Turn every feature back on",
    "trial.keep": "Subscribe and you keep your menu, tables and all your data.",
    "trial.activate": "Activate the subscription",
  },
  fr: {
    "nav.enter": "Accéder au logiciel",
    "nav.try": "Essai gratuit",
    "hero.badge": "Logiciel pour restaurants, pizzerias et bars",
    "hero.title": "Le logiciel qui fait respirer votre établissement.",
    "hero.sub": "De la prise de commande à la cuisine, de la livraison au ticket. Reprehendo réunit salle, cuisine et caisse dans un seul flux. Créez votre démo sur mesure en 60 secondes.",
    "hero.cta": "Essayez gratuitement en 60 secondes",
    "cf.overline": "Démonstration commentée",
    "cf.title": "Voyez comment ça marche, en deux minutes",
    "cf.sub": "Un vrai service du début à la fin : table, commande, cuisine, note. Avec une voix qui explique et les sous-titres toujours affichés.",
    "cf.play": "Voir comment ça marche",
    "cf.resume": "Reprendre",
    "cf.pause": "Pause",
    "cf.again": "Recommencer",
    "cf.mute": "Couper le son",
    "cf.unmute": "Activer la voix",
    "cf.back": "Retour à la page principale",
    "cf.loading": "Préparation de la démonstration…",
    "cf.note": "Aucun enregistrement : ce que vous voyez est le fonctionnement réel. La voix démarre au toucher, comme sur tout téléphone.",
    "cf.cta": "L'essayer sur mon établissement",
    "cf.cta.sub": "Une minute suffit : quelques questions et votre démo est prête, avec carte et tables.",
    "cf.step.sala": "Salle",
    "cf.step.comanda": "Commande",
    "cf.step.cucina": "Cuisine",
    "cf.step.pronto": "Prêt",
    "cf.step.conto": "Note",
    "cf.scene.sala": "Tables en salle",
    "cf.scene.comanda": "Commande table S3",
    "cf.scene.cucina": "Écran cuisine",
    "cf.scene.conto": "Note table S3",
    "cf.tap": "À servir",
    "cf.free": "Libre",
    "cf.course1": "Pâtes",
    "cf.course2": "Pizza",
    "cf.send": "Envoyer en cuisine",
    "cf.cooking": "En préparation",
    "cf.oven": "Au four",
    "cf.ready": "Prêt",
    "cf.voice": "« Carbonara prête, table S3 »",
    "cf.total": "Total",
    "cf.cash": "Encaisser",
    "cf.split": "Partager",
    "cf.step.asporto": "À emporter",
    "cf.step.magazzino": "Stock",
    "cf.step.chiusura": "Clôture",
    "cf.step.prezzi": "Essai",
    "cf.scene.asporto": "À emporter et livraison",
    "cf.scene.magazzino": "Niveaux de stock",
    "cf.scene.chiusura": "Clôture de caisse",
    "cf.scene.prezzi": "Offres et essai gratuit",
    "cf.pickup": "Retrait",
    "cf.delivery": "Livraison",
    "cf.items": "plats",
    "cf.asporto.badge": "Salle et emporter dans le même service",
    "cf.stock.low": "Sous le seuil",
    "cf.stock.ok": "Disponible",
    "cf.stock.alert": "Guanciale bientôt épuisé : commandez",
    "cf.cashline": "Espèces",
    "cf.cardline": "Cartes",
    "cf.float": "Fonds de caisse",
    "cf.dayTotal": "Recette du jour",
    "cf.balanced": "Caisse équilibrée, aucun écart",
    "cf.plan.f1": "Commandes, cuisine et caisse",
    "cf.plan.f2": "À emporter, stock et réservations",
    "cf.plan.f3": "Voix en cuisine et statistiques",
    "cf.plan.freeNow": "Gratuit pendant la beta",
    "cf.plan.note": "Sans carte bancaire",
    "cf.step.prenotazioni": "Réservations",
    "cf.scene.prenotazioni": "Réservations du soir",
    "cf.scene.prezzi": "Tout inclus, en beta",
    "cf.book.incoming": "Appel : « Une table pour ce soir ? »",
    "cf.book.confirmed": "Confirmée",
    "cf.book.waiting": "Sur liste d'attente",
    "cf.book.badge": "Ajouter une réservation",
    "hero.note": "7 jours gratuits · sans carte bancaire · configurée pour votre activité",
    "feat.overline": "Fonctionnalités",
    "feat.title": "Tout sous contrôle. Fini le désordre.",
    "feat.orders.t": "Commandes et postes",
    "feat.orders.d": "Séparez par service et envoyez en Cuisine, Pizzeria ou Bar. Chaque plat a son statut, du feu à la table.",
    "feat.voice.t": "Écrans avec voix",
    "feat.voice.d": "La commande est lue à voix haute : les mains pleines de farine ne sont plus un problème.",
    "feat.split.t": "Notes séparées",
    "feat.split.d": "Partagez par personne ou par plat en trois touches. Plus de file à la caisse.",
    "feat.delivery.t": "À emporter et livraison",
    "feat.delivery.d": "Glovo, Deliveroo, Just Eat et Uber Eats avec les commissions déjà réglées.",
    "feat.stock.t": "Stock et recettes",
    "feat.stock.d": "Ingrédients liés aux plats et déduits automatiquement à l'envoi de la commande.",
    "feat.alerts.t": "Des tables qui vous appellent",
    "feat.alerts.d": "La table clignote et sonne après dix minutes d'attente : personne n'est oublié.",
    "feat.calls.t": "Appels depuis la table",
    "feat.calls.d": "Le client scanne le QR et demande le serveur ou l'addition d'un seul geste : la demande arrive en salle avec le numéro de table.",
    "feat.report.t": "Rapport de clôture",
    "feat.report.d": "À la clôture, vous recevez par e-mail les recettes, les couverts, l'écart de caisse et les plats les plus vendus.",
    "news.overline": "Mises à jour",
    "news.title": "Le produit évolue chaque semaine.",
    "news.sub": "Les dernières fonctions mises en service. Sans surcoût : tous les établissements en profitent.",
    "news.more": "Nouveautés de cette version",
    "how.overline": "Comment ça marche",
    "how.title": "Prêt en 3 étapes, sans technicien.",
    "how.1.t": "Répondez à 6 questions",
    "how.1.d": "Vous nous dites votre activité, votre service et les postes nécessaires.",
    "how.2.t": "Essayez 7 jours",
    "how.2.d": "Vous recevez votre application déjà configurée, avec carte de départ et tables prêtes.",
    "how.3.t": "Choisissez la formule",
    "how.3.d": "Vous passez à l'abonnement en gardant carte, tables et toutes vos données.",
    "trust.overline": "Confidentialité",
    "trust.title": "Qui voit vos recettes ? Personne, à part vous.",
    "trust.sub": "C\u2019est la bonne question à poser avant de signer. Voici la réponse, ligne par ligne.",
    "trust.seeT": "Ce que nous voyons",
    "trust.see1": "Nom de l\u2019établissement, contact, formule et échéance",
    "trust.see2": "Combien de plats, de tables et de personnes dans l\u2019équipe",
    "trust.see3": "Les fonctions activées et vos demandes d\u2019assistance",
    "trust.notT": "Ce que nous ne voyons jamais",
    "trust.not1": "Vos recettes : aucun montant, aucun total, aucune statistique de vente",
    "trust.not2": "Notes, paiements, pourboires, fonds de caisse et comptages",
    "trust.not3": "Les données de vos clients et de votre personnel",
    "trust.note": "Personne de l\u2019assistance n\u2019entre dans votre logiciel sans votre autorisation : l\u2019accès dure une heure, se ferme seul et reste inscrit dans votre registre.",
    "trust.cta": "Lire toutes les garanties",
    "price.overline": "Formules et tarifs",
    "price.title": "Des tarifs clairs, sans surprise.",
    "price.sub": "Changez de formule quand vous voulez. Mises à jour et assistance incluses.",
    "price.month": "par mois",
    "price.cta": "Commencer l'essai",
    "price.popular": "Le plus choisi",
    "plan.free.h": "Salle, tables et commandes|Services et écrans de postes|Notes et encaissements|20 réservations par mois|1 utilisateur",
    "plan.standard.h": "Réservations illimitées|Commandes lues à voix haute|À emporter et livraison|Agenda et liste d'attente|Historique des commandes|Jusqu'à 3 utilisateurs",
    "plan.pro.h": "Tout le Standard|Rapports de ventes mensuels|Stock avec recettes et déduction auto|Plan de salle et zones|Fichier clients et archives|Import de la carte depuis PDF ou Excel|Utilisateurs illimités",
    "final.title": "Mettons de l'ordre dans votre service.",
    "final.sub": "Le questionnaire prend une minute et vous rend l'application déjà montée pour votre établissement.",
    "footer.tag": "Logiciel de restauration · salle, cuisine, caisse et livraison au même endroit.",
    "footer.rights": "Tous droits réservés.",
    "footer.terms": "Conditions d'utilisation", "footer.privacy": "Politique de confidentialité", "footer.security": "Sécurité des données",
    "footer.status": "État du service",
    "wiz.accept.pre": "J'ai lu et j'accepte les", "wiz.accept.terms": "conditions d'utilisation",
    "wiz.accept.and": "et la", "wiz.accept.privacy": "politique de confidentialité",
    "wiz.accept.beta": "Je comprends que le produit est en version bêta, qu'il fonctionne sur une infrastructure tierce et qu'il ne remplace pas une caisse fiscale.",
    "wiz.err.accept": "Pour démarrer l'essai vous devez accepter les conditions",
    "wiz.public": "Trouvez votre solution",
    "wiz.setup": "Configuration initiale",
    "wiz.step": "question {n} sur {tot}",
    "wiz.recap": "récapitulatif",
    "wiz.q0": "Quel type d'établissement avez-vous ?",
    "wiz.q1": "Comment servez-vous vos clients ?",
    "wiz.q2": "Quels postes doivent recevoir les commandes ?",
    "wiz.q3": "Où sont vos tables ?",
    "wiz.q4": "Combien de personnes travaillent avec vous ?",
    "sit.cashed": "Encaissé",
    "sit.cashedSub": "déjà dans la caisse",
    "sit.toCollect": "À encaisser",
    "sit.toCollectSub": "{n} tables ouvertes",
    "sit.cashExpected": "Espèces attendues",
    "sit.cashExpectedSub": "dont {v} de fonds de caisse",
    "sit.lastCount": "Dernier comptage",
    "sit.lastCountSub": "écart sur les espèces",
    "sit.noCount": "pas encore fait",
    "sr.vsPast": "{p}% par rapport aux {n} mêmes jours",
    "sr.precloseTitle": "Je clôture le service ?",
    "sr.precloseIntro": "Vérifiez ce qui reste : la clôture ferme et archive aussi les tables ouvertes.",
    "sr.precloseMoney": "Attention : {v} pas encore encaissés. En clôturant, ils restent dehors.",
    "sr.precloseOk": "Oui, clôturer",
    "sr.precloseAnyway": "Clôturer quand même",
    "sr.precloseErr": "Vérifications indisponibles",
    "wiz.q5": "De quelles fonctions avez-vous besoin ?",
    "wiz.q6": "Votre application Reprehendo",
    "wiz.h5": "Tout le monde ne s'en sert pas : n'activez que ce qui vous intéresse, le reste n'apparaît pas. Vous pourrez les ajouter plus tard.",
    "wiz.extra.menu_fisso.t": "Menu fixe du jour",
    "wiz.extra.menu_fisso.d": "Menu à prix unique : le serveur choisit les plats à la commande et la note affiche une seule ligne",
    "wiz.extra.carta_qr.t": "Carte numérique avec QR sur la table",
    "wiz.extra.carta_qr.d": "Les clients lisent la carte sur leur téléphone : plus de réimpression",
    "wiz.extra.cassa_fiscale.t": "Liaison avec la caisse fiscale",
    "wiz.extra.cassa_fiscale.d": "L'application prépare le ticket pour votre caisse (Epson, RCH, Ditron, Custom, Olivetti)",
    "wiz.banco.q": "Avez-vous un comptoir chaud ou froid ?",
    "wiz.banco.tavola-calda.t": "Comptoir chaud",
    "wiz.banco.tavola-calda.d": "Plats chauds, croque-monsieur, piadines, rôtisserie",
    "wiz.banco.tavola-fredda.t": "Comptoir froid",
    "wiz.banco.tavola-fredda.d": "Salades, sandwichs, charcuterie et traiteur",
    "wiz.extra.note": "Pas sûr ? Laissez désactivé : deux touches dans « Fonctions actives » suffisent.",
    "wiz.h0": "Vous pouvez cocher plusieurs choix : bar et pizzeria, restaurant et bar, les trois… comme dans la réalité.",
    "wiz.other": "Décrivez en deux mots votre activité (ex. ferme-auberge, kiosque)",
    "wiz.h2": "Chaque poste a son écran : les plats n'arrivent qu'à celui qui les prépare. Nous avons présélectionné les postes habituels, à vous de décider.",
    "wiz.menu.t": "Charger une carte de départ",
    "wiz.menu.d": "Plats typiques des postes choisis, modifiables en un instant",
    "wiz.h3": "Nous créerons les zones choisies avec leur préfixe (S1, D1, G1…).",
    "wiz.team.solo": "Seulement moi",
    "wiz.float.t": "Celui qui encaisse a-t-il son propre fond de caisse ?",
    "wiz.float.d": "Typique en terrasse : le serveur encaisse à table et rend la monnaie sur son fond.",
    "wiz.float.amount": "Fond par personne (€)",
    "wiz.float.outdoor": "Personnes dehors",
    "wiz.motto.t": "La devise de votre établissement (facultatif)",
    "wiz.motto.ph": "Ex. Depuis 1962, la pizza se fait à la main",
    "wiz.motto.d": "Elle apparaîtra sur l'écran de connexion de l'équipe et sur l'addition. Modifiable à tout moment dans Paramètres.",
    "wiz.float.note": "En fin de service vous verrez ce que chacun a en main et ce qu'il doit verser. Modifiable à tout moment : qui fait la terrasse peut aussi faire la salle.",
    "wiz.team.more": "Plus de 10",
    "wiz.team.people": "{n} personnes",
    "wiz.plan": "Formule conseillée",
    "wiz.sum.act": "Activité",
    "wiz.sum.serv": "Service",
    "wiz.sum.dept": "Postes actifs",
    "wiz.sum.zones": "Zones",
    "wiz.sum.mods": "Fonctions activées",
    "wiz.sum.note": "Rien n'est figé : depuis Fonctions actives, activez ou désactivez chaque module quand vous voulez.",
    "wiz.back": "Retour",
    "wiz.next": "Suivant",
    "wiz.apply": "Créer mon application",
    "wiz.name": "Nom de votre établissement",
    "wiz.email": "Votre e-mail",
    "wiz.trial": "Essayer la démo sur mesure",
    "wiz.trial.note": "Nous écrivons uniquement pour le rappel de fin d'essai.",
    "wiz.err.act": "Choisissez au moins un type d'activité",
    "wiz.err.dept": "Choisissez au moins un poste",
    "wiz.err.email": "Saisissez un e-mail valide pour lancer l'essai",
    "wiz.vat": "Numéro de TVA (ou code fiscal)",
    "wiz.vat.note": "Le numéro de TVA identifie votre établissement de façon unique : il s'enregistre une seule fois. Le reste (nom, adresse, téléphone, carte) se complète ensuite depuis votre compte.",
    "wiz.err.vat": "Saisissez un numéro de TVA valide (11 chiffres), un code fiscal ou une TVA étrangère",
    "wiz.loading": "Chargement du questionnaire…",
    "login.title": "Accès établissement",
    "login.sub": "Connectez-vous avec le nom de votre établissement et le code reçu.",
    "login.name": "Nom de l'établissement",
    "login.code": "Code d'accès",
    "login.btn": "Entrer",
    "login.quiz": "Trouvez votre solution en 1 minute",
    "login.back": "Retour à la présentation",
    "trial.ready": "Votre démo sur mesure est prête pour {n} jours",
    "login.lost": "J'ai perdu mon code d'accès",
    "hero.have": "J'ai déjà un établissement",
    "rec.title": "J'ai perdu mon code",
    "rec.sub": "Indiquez l'e-mail utilisé à la création : nous envoyons un lien pour revenir tout de suite, avec le nouveau code.",
    "rec.email": "Votre e-mail",
    "rec.send": "Envoyez-moi le lien",
    "rec.note": "Par sécurité, l'ancien code est remplacé par le nouveau.",
    "rec.done": "C'est fait : si l'e-mail est celui enregistré, le lien arrive. Il vaut 30 minutes.",
    "rec.ok": "Compris",
    "rec.entered": "Bon retour dans {name}",
    "rec.expired": "Lien expiré : demandez-en un nouveau",
    "ob.title": "Premiers pas",
    "ob.sub": "{n} sur 4 faits. Touchez une ligne, on vous y emmène.",
    "ob.hide": "Masquer",
    "ob.step.tavolo": "Ouvrez une table en salle",
    "ob.step.comanda": "Ajoutez deux plats à la commande",
    "ob.step.cucina": "Envoyez-les en cuisine et regardez l'écran",
    "ob.step.conto": "Clôturez la note et encaissez",
    "ob.help": "Tout est expliqué pas à pas dans « Manuel », dans le menu.", "ob.helpDemo": "L'essentiel est dans « Guide rapide », dans le menu.",
    "done.title": "Votre établissement est prêt",
    "done.sub": "Vous pouvez l'utiliser {n} jours avec toutes les fonctions.",
    "done.venue": "Nom de l'établissement", "done.code": "Code d'accès", "done.pin": "Code PIN du gérant",
    "done.copy": "Copier les infos", "done.copied": "Infos copiées",
    "done.enter": "Entrer dans l'établissement",
    "done.mail": "Nous avons aussi envoyé ces informations à {mail} : conservez-les pour vous connecter d'un autre téléphone.",
    "done.next": "Dès l'entrée vous trouverez « Premiers pas » : quatre choses à essayer pour tout comprendre.",
    "trial.how": "Connectez-vous comme Propriétaire avec le PIN {pin}. Pour revenir : établissement {slug}, code {code} — conservez-le.",
    "trial.left": "Essai gratuit : {n} jours restants",
    "install.title": "Gardez-le sur votre téléphone",
    "install.sub": "Ajoutez Reprehendo à l'écran d'accueil : il s'ouvre en plein écran, comme une app.",
    "install.ios": "Sur iPhone : touchez Partager, puis « Sur l'écran d'accueil ».",
    "install.iosStep": "Partager → Écran d'accueil",
    "install.cta": "Ajouter à l'accueil",
    "install.later": "Plus tard",
    "install.titlePc": "Gardez-le sur l'ordinateur",
    "install.subPc": "Installez Reprehendo : il s'ouvre dans sa propre fenêtre, sans barres du navigateur.",
    "install.ctaPc": "Installer sur l'ordinateur",
    "install.manual": "Dans le menu du navigateur, choisissez « Installer » ou « Sur l'écran d'accueil ».",
    "install.manualStep": "Menu → Installer",
    "nav.installa": "Installer l'app",
    "trial.over": "Essai terminé : vous êtes sur la formule Gratuite",
    "trial.overKeep": "Salle, commandes, écrans et notes restent actifs. Vos données sont conservées encore {n} jours.",
    "trial.reactivate": "Réactiver toutes les fonctions",
    "trial.keep": "Abonnez-vous et gardez carte, tables et toutes vos données.",
    "trial.activate": "Activer l'abonnement",
  },
  de: {
    "nav.enter": "Zur Verwaltung",
    "nav.try": "Kostenlos testen",
    "hero.badge": "Kassen- und Verwaltungssystem für Restaurants, Pizzerien und Bars",
    "hero.title": "Die Software, die Ihrem Betrieb Luft verschafft.",
    "hero.sub": "Von der Bestellung in die Küche, von der Lieferung bis zum Bon. Reprehendo verbindet Service, Küche und Kasse in einem Ablauf. Ihre passende Demo in 60 Sekunden.",
    "hero.cta": "Gratis in 60 Sekunden testen",
    "cf.overline": "Erklärte Vorführung",
    "cf.title": "Sehen Sie in zwei Minuten, wie es läuft",
    "cf.sub": "Ein echter Service von Anfang bis Ende: Tisch, Bestellung, Küche, Rechnung. Mit erklärender Stimme und ständigen Untertiteln.",
    "cf.play": "Sehen, wie es funktioniert",
    "cf.resume": "Weiter",
    "cf.pause": "Pause",
    "cf.again": "Von vorn",
    "cf.mute": "Ton aus",
    "cf.unmute": "Stimme an",
    "cf.back": "Zurück zur Hauptseite",
    "cf.loading": "Vorführung wird vorbereitet…",
    "cf.note": "Keine Aufzeichnung: Sie sehen die echte Funktionsweise. Die Stimme startet beim Antippen, wie auf jedem Handy.",
    "cf.cta": "In meinem Betrieb testen",
    "cf.cta.sub": "Eine Minute genügt: wenige Fragen und Ihre Demo ist fertig, mit Karte und Tischen.",
    "cf.step.sala": "Saal",
    "cf.step.comanda": "Bestellung",
    "cf.step.cucina": "Küche",
    "cf.step.pronto": "Fertig",
    "cf.step.conto": "Rechnung",
    "cf.scene.sala": "Tische im Saal",
    "cf.scene.comanda": "Bestellung Tisch S3",
    "cf.scene.cucina": "Küchenmonitor",
    "cf.scene.conto": "Rechnung Tisch S3",
    "cf.tap": "Zu servieren",
    "cf.free": "Frei",
    "cf.course1": "Pasta",
    "cf.course2": "Pizza",
    "cf.send": "In die Küche senden",
    "cf.cooking": "In Zubereitung",
    "cf.oven": "Im Ofen",
    "cf.ready": "Fertig",
    "cf.voice": "„Carbonara fertig, Tisch S3“",
    "cf.total": "Gesamt",
    "cf.cash": "Kassieren",
    "cf.split": "Teilen",
    "cf.step.asporto": "Abholung",
    "cf.step.magazzino": "Lager",
    "cf.step.chiusura": "Abschluss",
    "cf.step.prezzi": "Testen",
    "cf.scene.asporto": "Abholung und Lieferung",
    "cf.scene.magazzino": "Lagerbestand",
    "cf.scene.chiusura": "Kassenabschluss",
    "cf.scene.prezzi": "Pakete und Gratistest",
    "cf.pickup": "Abholung",
    "cf.delivery": "Lieferung",
    "cf.items": "Gerichte",
    "cf.asporto.badge": "Saal und Abholung in einem Service",
    "cf.stock.low": "Unter der Grenze",
    "cf.stock.ok": "Verfügbar",
    "cf.stock.alert": "Guanciale geht aus: nachordern",
    "cf.cashline": "Bargeld",
    "cf.cardline": "Karten",
    "cf.float": "Wechselgeld",
    "cf.dayTotal": "Tagesumsatz",
    "cf.balanced": "Kasse stimmt, keine Differenz",
    "cf.plan.f1": "Bestellungen, Küche und Kasse",
    "cf.plan.f2": "Abholung, Lager und Reservierungen",
    "cf.plan.f3": "Stimme in der Küche und Statistik",
    "cf.plan.freeNow": "Während der Beta kostenlos",
    "cf.plan.note": "Ohne Kreditkarte",
    "cf.step.prenotazioni": "Reservierungen",
    "cf.scene.prenotazioni": "Reservierungen für heute",
    "cf.scene.prezzi": "Alles inklusive, in der Beta",
    "cf.book.incoming": "Anruf: „Ein Tisch für heute Abend?“",
    "cf.book.confirmed": "Bestätigt",
    "cf.book.waiting": "Auf der Warteliste",
    "cf.book.badge": "Reservierung hinzufügen",
    "hero.note": "7 Tage gratis · keine Kreditkarte · auf Ihren Betrieb eingerichtet",
    "feat.overline": "Funktionen",
    "feat.title": "Alles im Griff. Kein Chaos mehr.",
    "feat.orders.t": "Bestellungen und Stationen",
    "feat.orders.d": "Nach Gängen trennen und an Küche, Pizzeria oder Bar senden. Jedes Gericht hat seinen Status, vom Herd bis an den Tisch.",
    "feat.voice.t": "Monitore mit Stimme",
    "feat.voice.d": "Die Bestellung wird vorgelesen: mehlige Hände sind kein Problem mehr.",
    "feat.split.t": "Rechnung teilen",
    "feat.split.d": "Nach Personen oder nach Gerichten in drei Schritten. Keine Schlange an der Kasse.",
    "feat.delivery.t": "Abholung und Lieferung",
    "feat.delivery.d": "Glovo, Deliveroo, Just Eat und Uber Eats mit bereits gesetzten Provisionen.",
    "feat.stock.t": "Lager und Rezepte",
    "feat.stock.d": "Zutaten mit Gerichten verknüpft und beim Senden automatisch abgezogen.",
    "feat.alerts.t": "Tische, die sich melden",
    "feat.alerts.d": "Nach zehn Minuten Wartezeit blinkt und piept der Tisch: niemand wird vergessen.",
    "feat.calls.t": "Rufe vom Tisch",
    "feat.calls.d": "Der Gast scannt den QR-Code und bittet mit einem Tipp um Service oder die Rechnung: der Ruf erreicht den Service mit der Tischnummer.",
    "feat.report.t": "Abschlussbericht",
    "feat.report.d": "Nach dem Tagesabschluss kommen Einnahmen, Gedecke, Kassendifferenz und Verkaufsschlager per E-Mail.",
    "news.overline": "Neuerungen",
    "news.title": "Das Produkt wächst jede Woche.",
    "news.sub": "Die neuesten Funktionen sind live. Ohne Aufpreis: alle Lokale erhalten sie.",
    "news.more": "Neu in dieser Version",
    "how.overline": "So funktioniert es",
    "how.title": "In 3 Schritten bereit, ohne Techniker.",
    "how.1.t": "6 Fragen beantworten",
    "how.1.d": "Sie sagen uns Betriebsart, Service und benötigte Stationen.",
    "how.2.t": "7 Tage testen",
    "how.2.d": "Sie erhalten Ihre App fertig eingerichtet, mit Startkarte und Tischen.",
    "how.3.t": "Tarif wählen",
    "how.3.d": "Sie wechseln zum Abo und behalten Karte, Tische und alle Daten.",
    "trust.overline": "Datenschutz",
    "trust.title": "Wer sieht deine Einnahmen? Niemand außer dir.",
    "trust.sub": "Das ist die richtige Frage, bevor man etwas unterschreibt. Hier die Antwort, Zeile für Zeile.",
    "trust.seeT": "Was wir sehen",
    "trust.see1": "Name des Lokals, Ansprechpartner, Tarif und Ablaufdatum",
    "trust.see2": "Wie viele Gerichte, Tische und Mitarbeiter du hast",
    "trust.see3": "Welche Funktionen aktiv sind und deine Support-Anfragen",
    "trust.notT": "Was wir nie sehen",
    "trust.not1": "Deine Einnahmen: kein Betrag, keine Summe, keine Verkaufsstatistik",
    "trust.not2": "Rechnungen, Zahlungen, Trinkgeld, Kassenbestand und Zählungen",
    "trust.not3": "Die Daten deiner Gäste und deiner Mitarbeiter",
    "trust.note": "Niemand vom Support betritt dein System ohne deine Freigabe: der Zugang gilt eine Stunde, endet von selbst und bleibt in deinem Protokoll stehen.",
    "trust.cta": "Alle Garantien lesen",
    "price.overline": "Tarife und Preise",
    "price.title": "Klare Preise, keine Überraschungen.",
    "price.sub": "Tarif jederzeit wechselbar. Updates und Support immer inklusive.",
    "price.month": "pro Monat",
    "price.cta": "Test starten",
    "price.popular": "Am häufigsten gewählt",
    "plan.free.h": "Service, Tische und Bestellungen|Gänge und Stationsmonitore|Rechnungen und Zahlungen|20 Reservierungen pro Monat|1 Benutzer",
    "plan.standard.h": "Unbegrenzte Reservierungen|Bestellungen werden vorgelesen|Abholung und Lieferung|Kalender und Warteliste|Bestellverlauf|Bis zu 3 Benutzer",
    "plan.pro.h": "Alles aus Standard|Monatliche Verkaufsberichte|Lager mit Rezepten und Auto-Abzug|Tischplan und Bereiche|Kundenkartei und Archiv|Speisekarten-Import aus PDF oder Excel|Unbegrenzte Benutzer",
    "final.title": "Bringen wir Ordnung in Ihren Service.",
    "final.sub": "Der Fragebogen dauert eine Minute und liefert die App, fertig auf Ihren Betrieb zugeschnitten.",
    "footer.tag": "Gastronomie-Software · Service, Küche, Kasse und Lieferung an einem Ort.",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.terms": "Nutzungsbedingungen", "footer.privacy": "Datenschutzerklärung", "footer.security": "Datensicherheit",
    "footer.status": "Servicestatus",
    "wiz.accept.pre": "Ich habe die", "wiz.accept.terms": "Nutzungsbedingungen",
    "wiz.accept.and": "und die", "wiz.accept.privacy": "Datenschutzerklärung",
    "wiz.accept.beta": "Mir ist klar, dass das Produkt in der Beta ist, auf Infrastruktur Dritter läuft und keine Registrierkasse ersetzt.",
    "wiz.err.accept": "Für den Test müssen Sie die Bedingungen akzeptieren",
    "wiz.public": "Finden Sie Ihre Lösung",
    "wiz.setup": "Ersteinrichtung",
    "wiz.step": "Frage {n} von {tot}",
    "wiz.recap": "Zusammenfassung",
    "wiz.q0": "Welche Art von Betrieb führen Sie?",
    "wiz.q1": "Wie bedienen Sie Ihre Gäste?",
    "wiz.q2": "Welche Stationen sollen die Bestellungen erhalten?",
    "wiz.q3": "Wo stehen Ihre Tische?",
    "wiz.q4": "Wie viele Personen arbeiten mit Ihnen?",
    "sit.cashed": "Eingenommen",
    "sit.cashedSub": "schon in der Kasse",
    "sit.toCollect": "Noch offen",
    "sit.toCollectSub": "{n} offene Tische",
    "sit.cashExpected": "Erwartetes Bargeld",
    "sit.cashExpectedSub": "inkl. {v} Wechselgeld",
    "sit.lastCount": "Letzte Zählung",
    "sit.lastCountSub": "Bargelddifferenz",
    "sit.noCount": "noch nicht gemacht",
    "sr.vsPast": "{p}% gegenüber den letzten {n} gleichen Tagen",
    "sr.precloseTitle": "Abend abschließen?",
    "sr.precloseIntro": "Prüfen Sie, was offen bleibt: beim Abschluss werden offene Tische geschlossen und archiviert.",
    "sr.precloseMoney": "Achtung: {v} noch nicht eingenommen. Beim Abschluss bleiben sie offen.",
    "sr.precloseOk": "Ja, abschließen",
    "sr.precloseAnyway": "Trotzdem abschließen",
    "sr.precloseErr": "Prüfungen nicht verfügbar",
    "wiz.q5": "Welche dieser Funktionen brauchen Sie?",
    "wiz.q6": "Ihre Reprehendo-App",
    "wiz.h5": "Nicht jeder nutzt sie: Schalten Sie nur ein, was Sie brauchen. Der Rest erscheint nicht. Später jederzeit ergänzbar.",
    "wiz.extra.menu_fisso.t": "Festes Tagesmenü",
    "wiz.extra.menu_fisso.d": "Menü zum Festpreis: Der Kellner wählt die Gerichte bei der Bestellung, die Rechnung zeigt eine Zeile",
    "wiz.extra.carta_qr.t": "Digitale Karte mit QR am Tisch",
    "wiz.extra.carta_qr.d": "Gäste lesen die Karte am Handy: kein Nachdruck bei Preisänderungen",
    "wiz.extra.cassa_fiscale.t": "Anbindung an die Registrierkasse",
    "wiz.extra.cassa_fiscale.d": "Die App erstellt den Bon für Ihre Kasse (Epson, RCH, Ditron, Custom, Olivetti)",
    "wiz.banco.q": "Haben Sie eine warme oder kalte Theke?",
    "wiz.banco.tavola-calda.t": "Warme Theke",
    "wiz.banco.tavola-calda.d": "Warme Gerichte, Toasts, Piadine, Rotisserie",
    "wiz.banco.tavola-fredda.t": "Kalte Theke",
    "wiz.banco.tavola-fredda.d": "Salate, Sandwiches, Feinkost und Aufschnitt",
    "wiz.extra.note": "Unsicher? Aus lassen: zwei Tipps in «Aktive Funktionen» genügen.",
    "wiz.h0": "Mehrfachauswahl möglich: Bar und Pizzeria, Restaurant und Bar, alle drei… genau wie in der Realität.",
    "wiz.other": "Beschreiben Sie Ihren Betrieb kurz (z. B. Landgasthof, Kiosk)",
    "wiz.h2": "Jede Station hat ihren Monitor: Gerichte erreichen nur die Person, die sie zubereitet. Die üblichen Stationen sind vorausgewählt, Sie entscheiden.",
    "wiz.menu.t": "Startkarte laden",
    "wiz.menu.d": "Typische Gerichte der gewählten Stationen, jederzeit änderbar",
    "wiz.h3": "Wir erstellen die gewählten Bereiche mit eigenem Kürzel (S1, D1, G1…).",
    "wiz.team.solo": "Nur ich",
    "wiz.float.t": "Hat wer kassiert ein eigenes Wechselgeld?",
    "wiz.float.d": "Typisch draußen: der Kellner kassiert am Tisch und gibt Wechselgeld aus seinem Bestand.",
    "wiz.float.amount": "Wechselgeld pro Person (€)",
    "wiz.float.outdoor": "Personen draußen",
    "wiz.motto.t": "Das Motto Ihres Betriebs (optional)",
    "wiz.motto.ph": "Z. B. Seit 1962 Pizza von Hand",
    "wiz.motto.d": "Es erscheint auf dem Anmeldebildschirm des Teams und auf der Gästerechnung. Jederzeit in den Einstellungen änderbar.",
    "wiz.float.note": "Am Ende des Service sehen Sie, wie viel jede Person hält und einzahlen muss. Jederzeit änderbar: wer draußen arbeitet, kann auch drinnen arbeiten.",
    "wiz.team.more": "Mehr als 10",
    "wiz.team.people": "{n} Personen",
    "wiz.plan": "Empfohlener Tarif",
    "wiz.sum.act": "Betrieb",
    "wiz.sum.serv": "Service",
    "wiz.sum.dept": "Aktive Stationen",
    "wiz.sum.zones": "Bereiche",
    "wiz.sum.mods": "Aktivierte Funktionen",
    "wiz.sum.note": "Nichts ist endgültig: unter Aktive Funktionen schalten Sie jedes Modul jederzeit ein oder aus.",
    "wiz.back": "Zurück",
    "wiz.next": "Weiter",
    "wiz.apply": "Meine App erstellen",
    "wiz.name": "Name Ihres Betriebs",
    "wiz.email": "Ihre E-Mail",
    "wiz.trial": "Passende Demo testen",
    "wiz.trial.note": "Wir schreiben nur zur Erinnerung an das Testende.",
    "wiz.err.act": "Wählen Sie mindestens eine Betriebsart",
    "wiz.err.dept": "Wählen Sie mindestens eine Station",
    "wiz.err.email": "Geben Sie eine gültige E-Mail für den Test ein",
    "wiz.vat": "USt-IdNr. (oder Steuernummer)",
    "wiz.vat.note": "Die USt-IdNr. identifiziert Ihren Betrieb eindeutig: Sie wird nur einmal registriert. Alles andere (Name, Adresse, Telefon, Karte) ergänzen Sie später in Ihrem Konto.",
    "wiz.err.vat": "Geben Sie eine gültige USt-IdNr. (11 Ziffern), Steuernummer oder ausländische USt-IdNr. ein",
    "wiz.loading": "Fragebogen wird geladen…",
    "login.title": "Betriebs-Anmeldung",
    "login.sub": "Melden Sie sich mit dem Namen Ihres Betriebs und dem erhaltenen Code an.",
    "login.name": "Name des Betriebs",
    "login.code": "Zugangscode",
    "login.btn": "Anmelden",
    "login.quiz": "Finden Sie Ihre Lösung in 1 Minute",
    "login.back": "Zurück zur Übersicht",
    "trial.ready": "Ihre eingerichtete Demo ist {n} Tage bereit",
    "login.lost": "Ich habe meinen Zugangscode verloren",
    "hero.have": "Ich habe schon einen Betrieb",
    "rec.title": "Code verloren",
    "rec.sub": "Geben Sie die E-Mail der Anmeldung ein: wir senden einen Link zum direkten Einstieg und den neuen Code.",
    "rec.email": "Ihre E-Mail",
    "rec.send": "Link senden",
    "rec.note": "Aus Sicherheitsgründen wird der alte Code durch den neuen ersetzt.",
    "rec.done": "Erledigt: wenn die E-Mail registriert ist, kommt der Link gleich. Gültig 30 Minuten.",
    "rec.ok": "Verstanden",
    "rec.entered": "Willkommen zurück in {name}",
    "rec.expired": "Link abgelaufen: bitte neu anfordern",
    "ob.title": "Erste Schritte",
    "ob.sub": "{n} von 4 erledigt. Zeile antippen, wir bringen Sie hin.",
    "ob.hide": "Ausblenden",
    "ob.step.tavolo": "Öffnen Sie einen Tisch im Saal",
    "ob.step.comanda": "Zwei Gerichte zur Bestellung hinzufügen",
    "ob.step.cucina": "In die Küche senden und den Monitor ansehen",
    "ob.step.conto": "Rechnung abschließen und kassieren",
    "ob.help": "Alles Schritt für Schritt im «Handbuch» im Menü.", "ob.helpDemo": "Das Wichtigste steht in der «Kurzanleitung» im Menü.",
    "done.title": "Ihr Betrieb ist bereit",
    "done.sub": "Sie können ihn {n} Tage mit allen Funktionen nutzen.",
    "done.venue": "Betriebsname", "done.code": "Zugangscode", "done.pin": "Inhaber-PIN",
    "done.copy": "Daten kopieren", "done.copied": "Daten kopiert",
    "done.enter": "Betrieb öffnen",
    "done.mail": "Wir haben diese Daten auch an {mail} gesendet: aufbewahren, damit Sie sich von einem anderen Handy anmelden können.",
    "done.next": "Nach dem Einstieg finden Sie «Erste Schritte»: vier Dinge zum Ausprobieren.",
    "trial.how": "Melden Sie sich als Inhaber mit PIN {pin} an. Für den Wiedereinstieg: Betrieb {slug}, Code {code} — gut aufbewahren.",
    "trial.left": "Kostenloser Test: {n} Tage übrig",
    "install.title": "Behalten Sie es auf dem Handy",
    "install.sub": "Fügen Sie Reprehendo zum Startbildschirm hinzu: es öffnet im Vollbild, wie eine App.",
    "install.ios": "Auf dem iPhone: Teilen antippen, dann „Zum Home-Bildschirm“.",
    "install.iosStep": "Teilen → Zum Home-Bildschirm",
    "install.cta": "Zum Startbildschirm",
    "install.later": "Später",
    "install.titlePc": "Behalten Sie es auf dem Computer",
    "install.subPc": "Reprehendo installieren: es öffnet in einem eigenen Fenster, ohne Browserleisten.",
    "install.ctaPc": "Auf dem Computer installieren",
    "install.manual": "Wählen Sie im Browsermenü „Installieren“ oder „Zum Startbildschirm“.",
    "install.manualStep": "Menü → Installieren",
    "nav.installa": "App installieren",
    "trial.over": "Testphase beendet: Sie sind im Gratis-Tarif",
    "trial.overKeep": "Saal, Bestellungen, Monitore und Rechnungen bleiben aktiv. Ihre Daten bleiben noch {n} Tage gespeichert.",
    "trial.reactivate": "Alle Funktionen reaktivieren",
    "trial.keep": "Mit einem Abo behalten Sie Karte, Tische und alle Daten.",
    "trial.activate": "Abo aktivieren",
  },
};

Object.keys(D).forEach((l) => Object.assign(D[l], APP_D[l], MAN_D[l], PAGE_D[l]));

const detect = () => {  const saved = localStorage.getItem("rh_lang");
  if (saved && D[saved]) return saved;
  const nav = (navigator.language || "it").slice(0, 2).toLowerCase();
  return D[nav] ? nav : "it";
};

const Ctx = createContext(null);

// Traduzione in una lingua indicata: serve quando si annuncia il cambio di lingua stesso.
export const tl = (lang, key, vars = {}) => {
  const raw = D[lang]?.[key] ?? D.it[key] ?? key;
  return Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), raw);
};

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);
  const setLang = useCallback((l) => {
    if (!D[l]) return;
    localStorage.setItem("rh_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback(
    (key, vars = {}) => tl(lang, key, vars),
    [lang]
  );
  return <Ctx.Provider value={{ lang, setLang, t, tl, langs: LANGS }}>{children}</Ctx.Provider>;
};

export const useI18n = () => useContext(Ctx);
